import { Component, signal } from '@angular/core';
import { ICardInfoData, CARD_INFO_ENUM } from '../../../../shared/interfaces/card-info.interface';
import { CardInfoService } from '../../../../shared/services/card-info.service';
import { CommonModule } from '@angular/common';
import { NumberedCard } from "../../../../shared/components/numbered-card/numbered-card";

@Component({
  selector: 'app-healthcare-card-number-container',
  imports: [CommonModule, NumberedCard],
  templateUrl: './healthcare-card-number-container.html',
  styleUrl: './healthcare-card-number-container.scss'
})
export class HealthcareCardNumberContainer {

  public cardInfo: ICardInfoData[] = []

  protected showPosts = signal(true);

  protected fromPost = 0;
  protected toPost = 3;

  private activeIndex = 0;
  private limit = 5;

  constructor(private cardInfoService: CardInfoService) {
  }

  ngOnInit() {
    this.cardInfo = this.cardInfoService.getNumberedCardInfo(CARD_INFO_ENUM.HEALTHCARE_MARKETING);
    this.startCarouselAutoplay();
  }

  private carouselTimeout = 4000;
  private timer: any;

  protected carouselSteps = [
    { value: 1, active: true },
    { value: 2, active: false },
    { value: 3, active: false },
  ];


  ngOnDestroy() {
    this.clearCarouselTimer();
  }

  private startCarouselAutoplay() {
    this.clearCarouselTimer();
    this.timer = setTimeout(() => {
      this.showPosts.update((show) => !show);
      this.nextStep();
      this.startCarouselAutoplay();

    }, this.carouselTimeout);
  }

  private clearCarouselTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  nextStep() {
    setTimeout(() => {
      this.showPosts.update((show) => !show);
      const current = this.activeStep;
      const next = current === 4 ? 1 : current + 1;
      this.activateCarousel(next);
    }, 50);
  }

  activateCarousel(value: number) {
    this.carouselSteps = this.carouselSteps.map(step => ({
      ...step,
      active: step.value === value
    }));
    this.updateActiveIndex();
    this.updateFromTo();
  }

  updateFromTo() {
    this.fromPost = this.activeStep - 1;
    this.toPost = this.activeStep + 2;
  }

  updateActiveIndex(){
    this.activeIndex = this.activeIndex === this.limit ? 0 : this.activeIndex + 1;
  }

  get activeStep(): number {
    return this.carouselSteps.find(step => step.active)?.value || 1;
  }

  get infoData(): ICardInfoData[] {
    return this.cardInfo.slice(this.fromPost, this.toPost);
  }

  get activeInfo(): ICardInfoData {
    return this.cardInfo[this.activeIndex] ?? this.cardInfo[0];
  }

}
